import { render, staticRenderFns } from "./deleteMaintainanceItem.vue?vue&type=template&id=54e2e96d&scoped=true"
import script from "./deleteMaintainanceItem.vue?vue&type=script&lang=js"
export * from "./deleteMaintainanceItem.vue?vue&type=script&lang=js"
import style0 from "./deleteMaintainanceItem.vue?vue&type=style&index=0&id=54e2e96d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2e96d",
  null
  
)

export default component.exports